import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdalService } from 'adal-angular4';

@Component({
  selector: 'root',
  template: ``
})
export class RootComponent implements OnInit {

  constructor(public adal: AdalService, private router: Router) {
  }

  ngOnInit() {
    if (this.adal.userInfo.authenticated) {
      this.router.navigate(['prices']);
    }
  }
}
